export class CoverImage {
	init() {
		const coverImage = document.querySelector('.cover-image');
		const firstSection = document.querySelector('.upcoming_concerts_container');

        if (typeof firstSection === 'undefined' || firstSection === null) {
            return;
        }

		if (coverImage) {
			firstSection.style.paddingTop = '300px';
		} else {
			firstSection.style.paddingTop = '80px';
		}
	}
}
